import { render } from "./ExtrasBadgeRequired.vue?vue&type=template&id=128e7424"
import script from "./ExtrasBadgeRequired.vue?vue&type=script&lang=js"
export * from "./ExtrasBadgeRequired.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/leaseitnow/ExtrasBadgeRequired.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "128e7424"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('128e7424', __exports__)) {
    api.reload('128e7424', __exports__)
  }
  
  module.hot.accept("./ExtrasBadgeRequired.vue?vue&type=template&id=128e7424", () => {
    api.rerender('128e7424', render)
  })

}


export default __exports__